import {DeviceFlat, FirmwareUpdateStatus} from "../../app/api/model/device";
import {PermissionLevel} from "../../app/api/model/user";
import {DeviceCommand} from "../../app/api/model/deviceHistory";
import {usePermission} from "../usePermission";
import {useDevicesCommandMutation} from "../../app/api/api";

export interface UseCancelFirmwareUpdateProps {
    devices: Array<DeviceFlat | undefined>;
}

export interface UseCancelFirmwareUpdateReturns {
    isActive: boolean;
    cancelFirmwareUpdate: () => void;
}

export const useCancelFirmwareUpdate = ({devices}: UseCancelFirmwareUpdateProps): UseCancelFirmwareUpdateReturns => {
    const {hasPermission} = usePermission();
    const [commandDevice] = useDevicesCommandMutation();

    const cancelFirmwareUpdate = () => {
        const deviceIds = devicesCurrentlyUpdatingFirmware
            .filter((d) => d !== undefined)
            .map((device) => device?.id) as Array<number>;
        //error handler is automatically handled by rtkQueryErrorLogger
        commandDevice({deviceIds: deviceIds, command: DeviceCommand.CANCEL_FIRMWARE_UPDATE});
    };

    const devicesCurrentlyUpdatingFirmware = devices.filter(
        (current) =>
            current?.firmwareUpdateStatus === FirmwareUpdateStatus.IN_PROGRESS ||
            current?.firmwareUpdateStatus === FirmwareUpdateStatus.SCHEDULED ||
            current?.firmwareUpdateStatus === FirmwareUpdateStatus.ERROR ||
            current?.firmwareUpdateStatus === FirmwareUpdateStatus.CANCELED ||
            current?.firmwareUpdateStatus === FirmwareUpdateStatus.WAITING_FOR_RETRY
    ) as DeviceFlat[];

    return {
        isActive: devicesCurrentlyUpdatingFirmware.length > 0 && hasPermission(PermissionLevel.MANAGER),
        cancelFirmwareUpdate,
    };
};
